import './QuestionCard.less';
import React from 'react';
import CheckboxesInput from "../checkboxes-input/CheckboxesInput";
import RadioButtonsInput from "../radio-buttons-input/RadioButtonsInput";
import __ from "../../../i18n";
import Icon from "../../../../bootstrap/components/icon/Icon";
import TextCompletionInput from "../text-completion-input/TextCompletionInput";
import WordArrangementInput from "../word-arrangement-input/WordArrangementInput";
import {
    TYPE_CHECKBOXES,
    TYPE_RADIO_BUTTONS,
    TYPE_TEXT_COMPLETION,
    TYPE_WORD_ARRANGEMENT
} from "../../../model-constants/quiz/types";
import DraftView from "../../../components/draft-view/DraftView";


export default function QuestionCard({value, onChange, anchorRef, question, options, questionPosition, quizEnded, isCorrect}) {

    const getInput = () => {
        switch (question.type) {
            case TYPE_RADIO_BUTTONS:
                return <RadioButtonsInput
                    anchorRef={anchorRef}
                    content={question.content}
                    options={options}
                    value={value}
                    onChange={onChange}
                    readOnly={quizEnded}
                />;
            case TYPE_CHECKBOXES:
                return <CheckboxesInput
                    anchorRef={anchorRef}
                    content={question.content}
                    options={options}
                    value={value}
                    onChange={onChange}
                    readOnly={quizEnded}
                />;
            case TYPE_TEXT_COMPLETION:
                return <TextCompletionInput
                    content={question.content}
                    options={options}
                    value={value}
                    onChange={onChange}
                    readOnly={quizEnded}
                />;
            case TYPE_WORD_ARRANGEMENT:
                return <WordArrangementInput
                    content={question.content}
                    options={options}
                    value={value}
                    onChange={onChange}
                    readOnly={quizEnded}
                />;
        }
    };

    return <div className="question-card">
        <div className="heading">
            <div className="title">
                {question.title}
                {/* {__('Question ::pos: ::title', {pos: questionPosition, title: question.title})} */}
            </div>
        </div>
        <div className="body">
            <div className="input-wrapper">
                {getInput()}
            </div>
            {
                quizEnded &&
                <div className={'feedback' + (isCorrect ? ' correct' : '')}>
                    <div className="result">
                        {
                            isCorrect
                            ? <><Icon name="tick"/> <span className="text">{__('Exact')}</span></>
                            : <><Icon name="times"/> <span className="text">{__('Wrong')}</span></>
                        }
                    </div>
                    {
                        !isCorrect &&
                        question.answer_explanation &&
                        <div className="answer-explanation">
                            <DraftView
                                contentState={JSON.parse(question.answer_explanation)}
                            />
                        </div>
                    }
                </div>
            }
        </div>
    </div>;
}

